// removed by extract-text-webpack-plugin
module.exports = {"horizontalscroller":"horizontalscroller__2HP2c","horizontalscroller__container":"horizontalscroller__container__hkPGz","horizontalscroller__items":"horizontalscroller__items__COM2B","horizontalscroller__bar":"horizontalscroller__bar__2oNJ8","horizontalscroller__thumb":"horizontalscroller__thumb__2WzHP","horizontalscroller__arrow":"horizontalscroller__arrow__33yaw","horizontalscroller__arrow_left":"horizontalscroller__arrow_left__iabmT","horizontalscroller__arrow_right":"horizontalscroller__arrow_right__3Ffgr"};


//////////////////
// WEBPACK FOOTER
// ./components/horizontal-scroller/style.css
// module id = RloS
// module chunks = 3